import { render, staticRenderFns } from "./add_subaccountlist_pz.vue?vue&type=template&id=2c5d650c&scoped=true&"
import script from "./add_subaccountlist_pz.vue?vue&type=script&lang=js&"
export * from "./add_subaccountlist_pz.vue?vue&type=script&lang=js&"
import style0 from "./add_subaccountlist_pz.vue?vue&type=style&index=0&id=2c5d650c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d650c",
  null
  
)

export default component.exports